import { ListInlineIconItem } from 'common/grid-list-items/list-inline-icon-item.js';
import { IconCoreProps } from 'common/icon/icon.js';
import { IconPropsV2 } from 'common/icon/iconV2.js';
import * as React from 'react';
import { isNotNullOrUndefined, predicatePopulatedStringOrNumber } from 'utilities/isType.js';

export type CustomObservationType = Omit<IconCoreProps<IconPropsV2>, 'v'> & {
  title: string;
  titleSecondary?: string;
  line1?: string;
  line2?: string;
  lineClass?: string;
};

export type MaybeCustomObservationType = CustomObservationType | undefined;

export const CustomObservations = ({ customObservation }: { customObservation?: MaybeCustomObservationType[] }) => {
  const CustomCompArr = customObservation
    ?.map((t, i) => {
      const hasValue = predicatePopulatedStringOrNumber(t?.line1) || predicatePopulatedStringOrNumber(t?.line2);

      if (hasValue) {
        const line1El = predicatePopulatedStringOrNumber(t.line1) ? (
          <span key={t.line1} className={t.lineClass}>{`${t.line1}`}</span>
        ) : null;
        const line2El = predicatePopulatedStringOrNumber(t.line2) ? (
          <span key={t.line2} className={t.lineClass}>{`${t.line2}`}</span>
        ) : null;
        const children = [line1El, line2El].filter(isNotNullOrUndefined);

        return (
          <React.Fragment key={`Custom: ${t.title ?? t.icon}${i}`}>
            <ListInlineIconItem key={`${t.title}${i}`} {...t} v={2} title={t.title}>
              {children}
            </ListInlineIconItem>
          </React.Fragment>
        );
      }
      return undefined;
    })
    .filter(isNotNullOrUndefined);

  return <>{CustomCompArr}</>;
};
